import { render, staticRenderFns } from "./SearchControl.vue?vue&type=template&id=2be2ca46&scoped=true"
import script from "./SearchControl.vue?vue&type=script&lang=js"
export * from "./SearchControl.vue?vue&type=script&lang=js"
import style0 from "./SearchControl.vue?vue&type=style&index=0&id=2be2ca46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2ca46",
  null
  
)

export default component.exports